import request from '@/utils/request'

// 登录获取token
export function login(data){
  return request({
    url:'Authorize/GetToken',
    method:'post',
    data:data
  })
}

// 区域列表
export function areaListApi(){
  // return request({
  //   url:'GetStoreyListJson.json',
  //   method:'get'
  // })
  // return
}

// 设备分类列表
export function deviceTypeListApi(){
  return request({
    url:'Equipment/GetEquipTypeListJson',
    method:'post'
  })
}

// 设备列表
export function deviceListApi(data){
  return request({
    url:'Equipment/GetEquipListJson',
    method:'post',
    data:data
  })
}

// 单设备实时数据查询
export function singleDeviceRealApi(data){
  return request({
    url:'Collector/GetLatestOne',
    method:'post',
    data:data
  })
}

// 多设备实时数据查询   设备数据  设备信息json
export function listDeviceRealApi(data){
  // return request({
  //   url:'GetLatestData.json',
  //   method:'get',
  //   // data:data
  // })
  return {
    "type": 1,
    "errorcode": 0,
    "message": "成功",
    "resultdata": {
      "rows": [
        {
          "EquipmentID": "7e17cabc-5093-4cd8-a3bd-b87832c4b59f",
          "EquipmentNo": "1#YWCJ_57",
          "EquipmentName": "1#液位差计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.2833184+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "5",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "8440dc0b-1b8b-472c-8a8d-f0d2ee6a287a",
          "EquipmentNo": "2#YWCJ_128",
          "EquipmentName": "2#液位差计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.2862478+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "5",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "23e9e454-201e-4c56-a95a-6edd0648dc7c",
          "EquipmentNo": "1#CBQWJ_3",
          "EquipmentName": "1#齿耙清污机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.2891793+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:52:41.2911324+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0b7e641f-0c0f-4e93-b0f0-4480fd482aef",
          "EquipmentNo": "2#CBQWJ_70",
          "EquipmentName": "2#齿耙清污机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.2931399+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:52:41.2960114+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4f7c6785-fc01-4a30-a113-da9772007ea3",
          "EquipmentNo": "1#LCFJ_30",
          "EquipmentName": "1#罗茨风机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.2989433+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:52:41.30097+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4d8753af-e702-4748-8311-e2ea08591a48",
          "EquipmentNo": "2#LCFJ_100",
          "EquipmentName": "2#罗茨风机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.3028507+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:52:41.3047994+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0b3efdf3-0621-4360-b607-10de5ba44690",
          "EquipmentNo": "LXSSSFLQ_263",
          "EquipmentName": "螺旋式砂水分离器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.3067502+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:52:41.308706+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "50b94be3-0188-4416-a452-ac86dd007091",
          "EquipmentNo": "SSYZJ_269",
          "EquipmentName": "输送压榨机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:52:41.3116379+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:52:41.3126127+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "60298179-6f54-4b27-97bd-5a0f6d66e28d",
          "EquipmentNo": "SGCYW_268",
          "EquipmentName": "事故池液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.2971918+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "6.049624",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "df0b0797-e0eb-43b5-b1a2-fc43c42ef587",
          "EquipmentNo": "YWJ_FKJ_257",
          "EquipmentName": "放空井液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.2991445+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0.4926215",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ec733271-fcd1-4d47-8ac3-a94f5d239004",
          "EquipmentNo": "SGCPH_267",
          "EquipmentName": "事故池PH",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3010909+08:00",
              "ParamNo": "PHZ_65",
              "ParamName": "PH值",
              "Value": "6.538195",
              "Unit": "",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3f73e6db-c2e8-4d68-a2ed-4d8eeb42285c",
          "EquipmentNo": "1#FKJQWB_13",
          "EquipmentName": "1#放空井潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.304022+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "47.18244",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3069554+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3089065+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ca68ee3d-517b-421c-9244-518fc8777a40",
          "EquipmentNo": "2#FKJQWB_84",
          "EquipmentName": "2#放空井潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3108588+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3128179+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3137903+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "50",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cec02e02-4850-4d79-b871-43c9a0fa0b6b",
          "EquipmentNo": "1#QWB_38",
          "EquipmentName": "1#潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3157402+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3176973+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "33.95363",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3206303+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "dc247cdb-1580-43e7-9dfd-037bf8e31e4f",
          "EquipmentNo": "2#QWB_107",
          "EquipmentName": "2#潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.321607+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3235539+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3264829+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6b3a3fa6-587d-4bd3-ad67-e0cfb12e54dc",
          "EquipmentNo": "1_01LSSYJBJ_61",
          "EquipmentName": "1_01立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3284376+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3303891+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "445b0ff6-ecf7-4401-91b4-fed4a0c3f404",
          "EquipmentNo": "1_02LSSYJBJ_62",
          "EquipmentName": "1_02立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3323427+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3343009+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "059fa63e-cfd8-4115-9a10-224c737e53fb",
          "EquipmentNo": "1_03LSSYJBJ_63",
          "EquipmentName": "1_03立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3352749+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3362536+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2a3cd0e9-9d64-47d9-ba4d-33b6221df221",
          "EquipmentNo": "1_04LSSYJBJ_64",
          "EquipmentName": "1_04立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3391819+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3401586+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "04ad165b-083d-4fc5-b5b1-da829d0c94a1",
          "EquipmentNo": "2_01LSSYJBJ_132",
          "EquipmentName": "2_01立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3421125+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3450475+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "bddf35b3-0b51-4b2d-9bc0-ac80ce225388",
          "EquipmentNo": "2_02LSSYJBJ_133",
          "EquipmentName": "2_02立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3469927+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3479687+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9a641b48-e9d0-4a77-93a5-07b5de4eb9ad",
          "EquipmentNo": "2_03LSSYJBJ_134",
          "EquipmentName": "2_03立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3499254+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.3518745+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c628690c-1200-4e36-b335-5abecaa369c7",
          "EquipmentNo": "2_04LSSYJBJ_135",
          "EquipmentName": "2_04立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:01.3528521+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:01.35578+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d6041cf7-2cfb-4433-8854-e67b033a87d0",
          "EquipmentNo": "3_01LSSYJBJ_162",
          "EquipmentName": "3_01立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5153099+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.517263+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "1bf95841-beaa-4269-8d2f-49b418c95a39",
          "EquipmentNo": "3_02LSSYJBJ_163",
          "EquipmentName": "3_02立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5192149+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5211685+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "8917b754-1ea4-4d93-a837-c2fa09f490ad",
          "EquipmentNo": "3_03LSSYJBJ_164",
          "EquipmentName": "3_03立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5240991+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5260491+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "72cc967e-7c2e-449f-a799-f5bd5ffeb2e0",
          "EquipmentNo": "3_04LSSYJBJ_165",
          "EquipmentName": "3_04立式水翼搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5280041+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.529958+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "e74ef3b4-3306-462a-b90a-8736f0236273",
          "EquipmentNo": "202308311444111815",
          "EquipmentName": "1#调节池潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.530934+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "50",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5328879+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5348398+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "34e1f02d-5404-4953-a20d-b8a548114ee6",
          "EquipmentNo": "202308311514505478",
          "EquipmentName": "2#调节池潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5377709+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "50",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5406999+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5426527+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a4baac27-5c32-4dfb-9397-884dd649a166",
          "EquipmentNo": "3#QWB_152",
          "EquipmentName": "3#调节池潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5446066+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5465593+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:27.5475352+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "50",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ca21ef82-c317-4f6e-9e43-e6d81a79e121",
          "EquipmentNo": "CSLL_DJC_230",
          "EquipmentName": "调节池出水流量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5494911+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "50",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d083bc42-28da-4163-a766-79f8f8dca04b",
          "EquipmentNo": "DJCPH_239",
          "EquipmentName": "调节池PH",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5514415+08:00",
              "ParamNo": "PHZ_65",
              "ParamName": "PH值",
              "Value": "14",
              "Unit": "",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "08c3e395-ca4c-4e92-96d4-9e92e0b711c3",
          "EquipmentNo": "DJCYW_240",
          "EquipmentName": "调节池液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:27.5533954+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "10",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "19ed7720-b300-475d-b5a5-eaff271c2cb6",
          "EquipmentNo": "NAHO1#YW_210",
          "EquipmentName": "NaHO1#液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7266455+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cb3d1ae9-c287-4500-8ba3-788a50ef218e",
          "EquipmentNo": "NAHO2#YW_212",
          "EquipmentName": "NaHO2#液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7295809+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "61055d6e-8901-4567-a936-f954eae54e1a",
          "EquipmentNo": "NAHO1#JYB_209",
          "EquipmentName": "NaHO1#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.732504+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7344572+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7364122+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7373914+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d4bbe01d-8061-4538-8427-a02b5ae263c7",
          "EquipmentNo": "NAHO2#JYB_211",
          "EquipmentName": "NaHO2#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7403208+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7432436+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7461782+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7481266+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f463ca4a-275d-4d9d-8490-c2fd35aeeeba",
          "EquipmentNo": "NAHO3#JYB_213",
          "EquipmentName": "NaHO3#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7500773+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7520383+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7539906+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7559433+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c01434a6-19c8-4da1-8730-8add80c7a019",
          "EquipmentNo": "NAHO4#JYB_215",
          "EquipmentName": "NaHO4#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7588882+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7618255+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7637617+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7647451+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ccabc5cd-2112-475a-8acd-00de1ccb75b4",
          "EquipmentNo": "NAHOXLB_216",
          "EquipmentName": "NaHO卸料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7667167+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7676876+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d84c965c-9f7a-47ab-868f-29f57927ad5f",
          "EquipmentNo": "CF1#YW_232",
          "EquipmentName": "除氟1#液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7696186+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0.8602225",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f728a790-9d62-4733-97f1-5c4dc49438de",
          "EquipmentNo": "CF2#YW_234",
          "EquipmentName": "除氟2#液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7705915+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0.8614522",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "00e5ed0d-44cd-495f-b5b8-3ddfc0c52a64",
          "EquipmentNo": "CF3#YW_236",
          "EquipmentName": "除氟3#液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7735194+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0.8294783",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "451cadf2-aa5d-4513-b6f8-cad748c68035",
          "EquipmentNo": "CF1#JYB_231",
          "EquipmentName": "除氟1#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7754721+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7774232+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7793791+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7823314+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "39a4dd03-098a-4000-9622-f9f46e6794fb",
          "EquipmentNo": "CF2#JYB_233",
          "EquipmentName": "除氟2#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7832896+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7862187+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "29.99573",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7881679+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "1.51",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7911025+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d333bace-8cf6-4a07-8d24-95bc297e98c4",
          "EquipmentNo": "CF3#JYB_235",
          "EquipmentName": "除氟3#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.7940311+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7950055+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7969551+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.7998893+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cf39cccd-9f4e-43e2-abce-ef28ab8ad230",
          "EquipmentNo": "CF4#JYB_237",
          "EquipmentName": "除氟4#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.8028152+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8047683+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8067384+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8086887+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "37f0bbe9-5cc9-44fc-b305-c7d5f04d2eb4",
          "EquipmentNo": "CFJY_CFJY_XLB_238",
          "EquipmentName": "除氟加药_卸料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.8116079+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8135555+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "1c66760a-9980-4bd3-8716-6b87479ffd56",
          "EquipmentNo": "CS1#YW_223",
          "EquipmentName": "草酸1#液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.814537+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f5d649e7-36bb-4d25-9398-dca2e7c8a4da",
          "EquipmentNo": "CS2#YW_225",
          "EquipmentName": "草酸2#液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.8164917+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "47d98e1b-1717-46ec-a56c-88e754da22be",
          "EquipmentNo": "CS1#JYB_222",
          "EquipmentName": "草酸1#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.8174685+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8203975+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8223447+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8252821+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cd849a33-21bb-444c-9411-deaaa6bbfca0",
          "EquipmentNo": "CS2#JYB_224",
          "EquipmentName": "草酸2#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.8262584+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8282052+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8311394+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8340693+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3b952d3b-2dc9-4d68-a0ac-c87149f58b59",
          "EquipmentNo": "CS3#JYB_226",
          "EquipmentName": "草酸3#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.8350433+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8369964+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8389507+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8409018+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "249b853d-fbcb-4eb8-b46c-c286bbbd3643",
          "EquipmentNo": "CS4#JYB_228",
          "EquipmentName": "草酸4#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.8418794+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8448069+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8467616+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8477371+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3fabac7b-d0b7-4009-8049-dae0fa6f3b51",
          "EquipmentNo": "CSXLB_229",
          "EquipmentName": "草酸卸料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:54:57.849702+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:54:57.8506662+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0c752367-af99-4ec8-aba2-a41f3b249dc5",
          "EquipmentNo": "1#XNJBJ_53",
          "EquipmentName": "1#絮凝搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.200326+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2032543+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "-32768",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2061829+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cd6b8cff-0108-408c-8f8b-51ae530dd310",
          "EquipmentNo": "HHJBJ_259",
          "EquipmentName": "混合搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2071589+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2091057+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c89168ff-cf04-4ef2-a327-9e1efdab998b",
          "EquipmentNo": "2#XNJBJ_112",
          "EquipmentName": "2#絮凝搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2110663+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "35.90676",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2120419+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2139907+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "31ac32fd-c9e5-4852-9af8-aa8309a2c5b7",
          "EquipmentNo": "1#ZXGNJ_59",
          "EquipmentName": "1#中心刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2149654+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.216926+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "8cae4b7b-4001-495d-a0bf-7bc08ecbbd85",
          "EquipmentNo": "2#ZXGNJ_130",
          "EquipmentName": "2#中心刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2188941+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2208271+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2754cc4c-bcfe-427b-b1bd-7a65ccabb8c0",
          "EquipmentNo": "1#SYWNB_41",
          "EquipmentName": "1#剩余污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2218035+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2227775+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a2487381-e3dd-4b26-bf54-ff1344da8f82",
          "EquipmentNo": "2#SYWNB_113",
          "EquipmentName": "2#剩余污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2247341+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.225718+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "bec220ce-b3c1-4f34-8bfb-b67247085f6e",
          "EquipmentNo": "202308311651061981",
          "EquipmentName": "3#剩余污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2266849+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2296419+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f22db29e-523d-4eff-8443-042f3c690226",
          "EquipmentNo": "4#SYWNB_175",
          "EquipmentName": "4#剩余污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2306021+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2325497+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "893b232b-4814-467a-902b-ab94f071c1fe",
          "EquipmentNo": "202308311652458265",
          "EquipmentName": "5#剩余污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2344989+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2364532+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0bdd780f-dac3-4dea-9464-ee074c2ab4b0",
          "EquipmentNo": "6#SYWNB_191",
          "EquipmentName": "6#剩余污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2374284+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:33.2393815+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "218d92ca-2ae6-4c15-af44-d57ddbdba3c0",
          "EquipmentNo": "1#CFCNW_7",
          "EquipmentName": "1#除氟池泥位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.2403665+08:00",
              "ParamNo": "NW_24",
              "ParamName": "泥位",
              "Value": "1.81467",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "28f7c32a-f270-408b-9fc0-003055a1adb3",
          "EquipmentNo": "2#CFCNW_78",
          "EquipmentName": "2#除氟池泥位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:33.242309+08:00",
              "ParamNo": "NW_24",
              "ParamName": "泥位",
              "Value": "1.865234",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6aac016b-b1bd-419a-a44d-c8209ca8f8f0",
          "EquipmentNo": "1#HHYHLB_17",
          "EquipmentName": "1#混合液回流泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.8861648+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.8900765+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.8920273+08:00",
              "ParamNo": "YXXHFK_39",
              "ParamName": "运行反馈",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "330c23bd-0ff9-470d-ba2f-1ad124e1b0c9",
          "EquipmentNo": "2#HHYHLB_87",
          "EquipmentName": "2#混合液回流泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.8959784+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.8978882+08:00",
              "ParamNo": "YXXHFK_39",
              "ParamName": "运行反馈",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.8998378+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "86427f6b-1aea-4ae5-8212-38295a9497e8",
          "EquipmentNo": "202309181655303167",
          "EquipmentName": "1#PH",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9008141+08:00",
              "ParamNo": "PHZ_65",
              "ParamName": "PH值",
              "Value": "0",
              "Unit": "",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "21bd11de-c117-435c-80fc-1b5c49143d22",
          "EquipmentNo": "1#ORP_1",
          "EquipmentName": "1#ORP",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9037467+08:00",
              "ParamNo": "ORPZ_1",
              "ParamName": "ORP值",
              "Value": "-263.5995",
              "Unit": "mv",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "63a11b1d-3547-4d8f-9a61-59497f09ea15",
          "EquipmentNo": "1#HLLL_14",
          "EquipmentName": "1#回流流量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9047211+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "5c9de72c-1967-41fb-a486-5c80d84f632d",
          "EquipmentNo": "2#PH_68",
          "EquipmentName": "2#PH",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9066766+08:00",
              "ParamNo": "PHZ_65",
              "ParamName": "PH值",
              "Value": "0",
              "Unit": "",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "87a5f273-8344-49f9-8ed8-c20da52d865d",
          "EquipmentNo": "2#ORP_67",
          "EquipmentName": "2#ORP",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9086266+08:00",
              "ParamNo": "ORPZ_1",
              "ParamName": "ORP值",
              "Value": "10.77838",
              "Unit": "mv",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b3a4d1f5-b4d4-48b3-9b1b-ade3fc3e17c7",
          "EquipmentNo": "2#HLLL_85",
          "EquipmentName": "2#回流流量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9115537+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c30e9b65-e90b-4253-84e8-aee753f1ac1a",
          "EquipmentNo": "1#PNB_35",
          "EquipmentName": "1#排泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9135147+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9164425+08:00",
              "ParamNo": "YXXHFK_39",
              "ParamName": "运行反馈",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "04a6b454-76e9-435f-99ca-04b501635fe9",
          "EquipmentNo": "1#PNF_36",
          "EquipmentName": "1#排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9174185+08:00",
              "ParamNo": "GDWFK_47",
              "ParamName": "关到位反馈",
              "Value": "未关到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9193803+08:00",
              "ParamNo": "ZDMS_52",
              "ParamName": "手/自动模式",
              "Value": "手动",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9223034+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9232763+08:00",
              "ParamNo": "KDWFK_48",
              "ParamName": "开到位反馈",
              "Value": "未开到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a68a9a7f-13f4-4393-967c-4dfaab981a04",
          "EquipmentNo": "2#PNB_104",
          "EquipmentName": "2#排泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9252286+08:00",
              "ParamNo": "YXXHFK_39",
              "ParamName": "运行反馈",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9271809+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "40f501f4-6ba8-48e8-bf45-ad7109194b89",
          "EquipmentNo": "2#PNF_105",
          "EquipmentName": "2#排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9291407+08:00",
              "ParamNo": "KDWFK_48",
              "ParamName": "开到位反馈",
              "Value": "未开到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9320804+08:00",
              "ParamNo": "ZDMS_52",
              "ParamName": "手/自动模式",
              "Value": "手动",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.935002+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9369531+08:00",
              "ParamNo": "GDWFK_47",
              "ParamName": "关到位反馈",
              "Value": "未关到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c30e9b65-e90b-4253-84e8-aee753f1ac1a1",
          "EquipmentNo": "1#PNB_35",
          "EquipmentName": "4#排泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9135147+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9164425+08:00",
              "ParamNo": "YXXHFK_39",
              "ParamName": "运行反馈",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "04a6b454-76e9-435f-99ca-04b501635fe91",
          "EquipmentNo": "1#PNF_36",
          "EquipmentName": "4#排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9174185+08:00",
              "ParamNo": "GDWFK_47",
              "ParamName": "关到位反馈",
              "Value": "未关到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9193803+08:00",
              "ParamNo": "ZDMS_52",
              "ParamName": "手/自动模式",
              "Value": "手动",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9223034+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9232763+08:00",
              "ParamNo": "KDWFK_48",
              "ParamName": "开到位反馈",
              "Value": "未开到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a68a9a7f-13f4-4393-967c-4dfaab981a041",
          "EquipmentNo": "2#PNB_104",
          "EquipmentName": "3#排泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9252286+08:00",
              "ParamNo": "YXXHFK_39",
              "ParamName": "运行反馈",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9271809+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "40f501f4-6ba8-48e8-bf45-ad7109194b891",
          "EquipmentNo": "2#PNF_105",
          "EquipmentName": "3#排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9291407+08:00",
              "ParamNo": "KDWFK_48",
              "ParamName": "开到位反馈",
              "Value": "未开到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9320804+08:00",
              "ParamNo": "ZDMS_52",
              "ParamName": "手/自动模式",
              "Value": "手动",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.935002+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:58:55.9369531+08:00",
              "ParamNo": "GDWFK_47",
              "ParamName": "关到位反馈",
              "Value": "未关到位",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "70b4b094-0fc5-4890-bea1-673f7d3e0c0e",
          "EquipmentNo": "PNLLJ_265",
          "EquipmentName": "排泥流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:58:55.9389063+08:00",
              "ParamNo": "PNLL_79",
              "ParamName": "排泥流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a2269817-5013-4fd0-825a-f8ef722802fa",
          "EquipmentNo": "1#YZJ_55",
          "EquipmentName": "1#压榨机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.081792+08:00",
              "ParamNo": "ZD_60",
              "ParamName": "自动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:19.0857195+08:00",
              "ParamNo": "SD_59",
              "ParamName": "手动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:19.0886332+08:00",
              "ParamNo": "BZD_58",
              "ParamName": "半自动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "335d3497-d25f-4094-9040-04edb903ac2a",
          "EquipmentNo": "1#WNJLB_50",
          "EquipmentName": "1#污泥进料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.0915521+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f9fcef4f-f5a8-4e0e-a2f9-eef4b6dba074",
          "EquipmentNo": "2#YZJ_127",
          "EquipmentName": "2#压榨机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.0935012+08:00",
              "ParamNo": "SD_59",
              "ParamName": "手动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:19.0954551+08:00",
              "ParamNo": "BZD_58",
              "ParamName": "半自动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:19.0964315+08:00",
              "ParamNo": "ZD_60",
              "ParamName": "自动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "16d6901d-c47f-4711-8d20-ad05a381d3fb",
          "EquipmentNo": "2#WNJLB_123",
          "EquipmentName": "2#污泥进料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.0983842+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "539db39e-2180-4f98-9819-6bd3c335b01f",
          "EquipmentNo": "1#JNF_20",
          "EquipmentName": "1#进泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1003373+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0e47069a-2519-4216-95e7-8f6188320423",
          "EquipmentNo": "1#CNF_6",
          "EquipmentName": "1#出泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.102292+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "777f6b11-2465-45b7-b294-625b29ff4a0d",
          "EquipmentNo": "1#JBJ_19",
          "EquipmentName": "1#搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1042467+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0b3c3074-ec50-4ba3-bd84-dd49871d3ac6",
          "EquipmentNo": "2#JNF_90",
          "EquipmentName": "2#进泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1062809+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "1585ac0a-09b0-4d42-bdc3-b9054505feb8",
          "EquipmentNo": "2#CNF_74",
          "EquipmentName": "2#出泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1081502+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a7d27ffa-4db9-4dbb-aa6c-e873c45c9283",
          "EquipmentNo": "2#JBJ_89",
          "EquipmentName": "2#搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1101056+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2dc0dd16-ab3e-4fa3-b3f7-6741ebebe446",
          "EquipmentNo": "1#WNJNB_51",
          "EquipmentName": "1#污泥进泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.113039+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d9fb0df5-3ddf-46ae-9ce3-83fbe873c2bf",
          "EquipmentNo": "2#WNJNB_124",
          "EquipmentName": "2#污泥进泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1149854+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a8593f5f-5faa-423f-84a7-fa7a0f907279",
          "EquipmentNo": "3#WNJNB_158",
          "EquipmentName": "3#污泥进泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1169397+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9767eab7-d988-406a-a02b-38b87a8350ca",
          "EquipmentNo": "1#TYB_47",
          "EquipmentName": "1#铁盐泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1179133+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "e1eabb17-fa46-416b-8e17-03f9e8ba3183",
          "EquipmentNo": "2#TYB_120",
          "EquipmentName": "2#铁盐泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1218227+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b2f6bb35-4121-44ee-938a-38f24bef2779",
          "EquipmentNo": "202309011821411981",
          "EquipmentName": "铁盐卸料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1227991+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cc5c0e22-0beb-4643-bd35-f788728ed3b7",
          "EquipmentNo": "1#DLB_10",
          "EquipmentName": "1#调理泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1257285+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4390d88d-f752-4655-81bb-54e57cd82ac0",
          "EquipmentNo": "2#DLB_81",
          "EquipmentName": "2#调理泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1276848+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cfb62426-4390-437d-9dd1-3ecc5fd6a73f",
          "EquipmentNo": "DLJXLB_242",
          "EquipmentName": "调理剂卸料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1296355+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "aa731dec-f918-45d5-8b49-f2b3442d462e",
          "EquipmentNo": "DLJBSF_241",
          "EquipmentName": "调理剂补水阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1315906+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a356d4b9-a0cc-4ddc-871b-673a4adfe4b7",
          "EquipmentNo": "1#DLJ_11",
          "EquipmentName": "1#叠螺机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1345181+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f42d9300-4533-4932-89dc-9f2c310e7fd3",
          "EquipmentNo": "2#DLJ_82",
          "EquipmentName": "2#叠螺机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.136472+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d65f9548-9896-4e64-8137-7a96ba4ced11",
          "EquipmentNo": "ZQXBSF_278",
          "EquipmentName": "自清洗补水阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1374503+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ebf8a103-9730-429e-9b60-944c7b98577d",
          "EquipmentNo": "ZQXHLF_279",
          "EquipmentName": "自清洗回流阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1393991+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f1d885d8-d420-44b4-a981-ceb9f500a365",
          "EquipmentNo": "1#QXB_39",
          "EquipmentName": "1#清洗泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1403798+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6796e677-b538-4e2c-a118-3da8aeb8a486",
          "EquipmentNo": "2#QXB_108",
          "EquipmentName": "2#清洗泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1423369+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "fcc888a1-1116-49e0-94af-11e8db88db2b",
          "EquipmentNo": "202309011826568677",
          "EquipmentName": "PAM-1#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1433085+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "fb848596-7fdd-40b3-b216-d29ef8e4829d",
          "EquipmentNo": "202309011828384714",
          "EquipmentName": "PAM-2#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1462364+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "303c3f41-c383-48c0-b742-df6367e49d8e",
          "EquipmentNo": "202309011829399512",
          "EquipmentName": "PAM-3#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1481875+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "be3f246d-c637-4956-ba4f-d8337292a9f7",
          "EquipmentNo": "1#SXJBQ_43",
          "EquipmentName": "1#水下搅拌器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1501406+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:19.1520989+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "1d79ba67-7bad-4767-b609-bde5b787cb48",
          "EquipmentNo": "2#SXJBQ_116",
          "EquipmentName": "2#水下搅拌器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1530736+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:19.1550287+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "94f935db-67b6-44d9-8620-14ddf3966844",
          "EquipmentNo": "1#ZNCYW_60",
          "EquipmentName": "1#贮泥池液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1569787+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a6d2d6e6-125f-4c26-b949-c0e11ae03ac4",
          "EquipmentNo": "2#ZNCYW_131",
          "EquipmentName": "2#贮泥池液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:19.1589298+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4b6a82c9-c5d1-4f85-bf48-11ac9f625df2",
          "EquipmentNo": "1#SXJBQ_YYQ_44",
          "EquipmentName": "1#水下搅拌器_厌氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0040312+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0079555+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "20735cab-ce11-4a43-8df8-1e200e8c88fd",
          "EquipmentNo": "1#SXJBQ_YQYQ_45",
          "EquipmentName": "1#水下搅拌器_预缺氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.010822+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0137451+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9cae02a6-46db-4ca5-84f9-b65a388eb7ac",
          "EquipmentNo": "202309181642265952",
          "EquipmentName": "1#ORP_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0157038+08:00",
              "ParamNo": "ORPZ_1",
              "ParamName": "ORP值",
              "Value": "0",
              "Unit": "mv",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "dc2d879d-fe70-4552-941c-47d89e1e49ba",
          "EquipmentNo": "202309181641449725",
          "EquipmentName": "2#ORP_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0186387+08:00",
              "ParamNo": "ORPZ_1",
              "ParamName": "ORP值",
              "Value": "0",
              "Unit": "mv",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d3b26fd7-f3bc-44ee-9bae-c7a10ea9f32d",
          "EquipmentNo": "202307141727265752",
          "EquipmentName": "3#ORP_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0205942+08:00",
              "ParamNo": "ORPZ_1",
              "ParamName": "ORP值",
              "Value": "0",
              "Unit": "mv",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "470436f7-6d11-4236-b1dc-6819481fc8fc",
          "EquipmentNo": "4#ORP_166",
          "EquipmentName": "4#ORP_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0235343+08:00",
              "ParamNo": "ORPZ_1",
              "ParamName": "ORP值",
              "Value": "0",
              "Unit": "mv",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "48ed8363-8e2d-4db9-bf39-6b3b14969613",
          "EquipmentNo": "1#LTSGNJ_29",
          "EquipmentName": "1#链条式刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0264378+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0283854+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "63b454cb-3db0-4e90-9ca2-085aa93a1343",
          "EquipmentNo": "2#LTSGNJ_99",
          "EquipmentName": "2#链条式刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0303409+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0322955+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b069e996-2b46-44fd-8e93-64ed648c44e0",
          "EquipmentNo": "3#LTSGNJ_148",
          "EquipmentName": "3#链条式刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0342589+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0362281+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "343f7cac-9557-4c9e-8adf-586e5c0e1202",
          "EquipmentNo": "4#LTSGNJ_173",
          "EquipmentName": "4#链条式刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0391407+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0430532+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c7e32a76-52ad-4f28-97b5-c640b0fa81cb",
          "EquipmentNo": "202309011440126464",
          "EquipmentName": "1#剩余污泥泵_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0469795+08:00",
              "ParamNo": "QT_33",
              "ParamName": "启停",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "37d53855-6527-4d0f-9669-513419709ca4",
          "EquipmentNo": "202309011441384944",
          "EquipmentName": "2#剩余污泥泵_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0498818+08:00",
              "ParamNo": "QT_33",
              "ParamName": "启停",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "316dfa0e-d269-49b9-8c09-ac5cfed3da17",
          "EquipmentNo": "1#HLWNB_15",
          "EquipmentName": "1#回流污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0518365+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0537884+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "965d0755-22fc-4d84-9abc-d6a0f25fd57d",
          "EquipmentNo": "2#HLWNB_86",
          "EquipmentName": "2#回流污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0586761+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0616008+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3a9a560e-31e3-418c-bba2-f25ab2180b13",
          "EquipmentNo": "1#NHLB_31",
          "EquipmentName": "1#内回流泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0635484+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0664889+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "32767",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0684354+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4c7c9c1d-62bd-4701-a8f4-d70125266b6f",
          "EquipmentNo": "2#NHLB_101",
          "EquipmentName": "2#内回流泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0703865+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0733175+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0752675+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "32767",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "727b38f5-1b5a-41eb-82a3-c2fb87f17264",
          "EquipmentNo": "202309211112153956",
          "EquipmentName": "1#罗茨风机_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.077223+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9d1521ae-a761-4149-9dd9-8d959d1dbdfc",
          "EquipmentNo": "202309211109548217",
          "EquipmentName": "2#罗茨风机_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0791816+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "开启",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ddb9c79f-5e19-4b43-b28c-70c743e40aba",
          "EquipmentNo": "3#LCFJ_149",
          "EquipmentName": "3#罗茨风机_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0811217+08:00",
              "ParamNo": "ZT_18",
              "ParamName": "状态",
              "Value": "关闭",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "253bce55-944d-4d0e-8df4-5b8dab28bacd",
          "EquipmentNo": "2#SXJBQ_YQYQ_118",
          "EquipmentName": "2#水下搅拌器_预缺氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0840535+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0860066+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9283f720-6102-44d0-b678-2353bfc5bb55",
          "EquipmentNo": "2#SXJBQ_YYQ_117",
          "EquipmentName": "2#水下搅拌器_厌氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0869865+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0889656+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3a629b7d-a1bf-49de-a180-471077826910",
          "EquipmentNo": "1#SXTLQ_QYQ_46",
          "EquipmentName": "1#水下推流器_缺氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0908888+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0918683+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "881184be-cfe5-4985-bee8-f3a4193dc96a",
          "EquipmentNo": "2#SXTLQ_QYQ_119",
          "EquipmentName": "2#水下推流器_缺氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0947978+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.0957785+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a1424558-05dd-4265-ad15-2272e2ec35d2",
          "EquipmentNo": "3#SXTLQ_QYQ_157",
          "EquipmentName": "3#水下推流器_缺氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.0987028+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.1006563+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3de1203c-a48c-4ed9-be7a-0e25876e8b27",
          "EquipmentNo": "4#SXTLQ_QYQ_176",
          "EquipmentName": "4#水下推流器_缺氧区",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1016323+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T14:59:43.1035838+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "fd7d924a-6558-4c1a-ab1d-3334fa2ab519",
          "EquipmentNo": "1#XFW_54",
          "EquipmentName": "1#悬浮物",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1045618+08:00",
              "ParamNo": "XFWND_57",
              "ParamName": "悬浮物浓度",
              "Value": "11720",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "43486524-c0ae-4fda-8ca6-52b888b6893d",
          "EquipmentNo": "1#RJY_40",
          "EquipmentName": "1#溶解氧",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1075019+08:00",
              "ParamNo": "ND_53",
              "ParamName": "浓度",
              "Value": "9034",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "441ae058-2860-4dc7-9bf5-1e5f3a753c61",
          "EquipmentNo": "202309191345304417",
          "EquipmentName": "1#液位差计_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1094475+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "9.909577",
              "Unit": "m",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6f1d7b35-cf23-4285-a3c6-3e08828fd434",
          "EquipmentNo": "2#XFW_126",
          "EquipmentName": "2#悬浮物",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1123782+08:00",
              "ParamNo": "XFWND_57",
              "ParamName": "悬浮物浓度",
              "Value": "6768",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "bece712b-f75f-4f9c-b16e-a42000462640",
          "EquipmentNo": "RJYND2_HYQZB_110",
          "EquipmentName": "2#溶解氧",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1143277+08:00",
              "ParamNo": "ND_53",
              "ParamName": "浓度",
              "Value": "-32768",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "237d524e-c008-461a-9d9a-810c6159b896",
          "EquipmentNo": "202309191346199439",
          "EquipmentName": "2#液位差计_生化池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1172635+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "8.927228",
              "Unit": "m",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b8502fd2-d0f8-4c81-8a64-7e7d4efd5c5b",
          "EquipmentNo": "3#XFW_161",
          "EquipmentName": "3#悬浮物",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1201953+08:00",
              "ParamNo": "XFWND_57",
              "ParamName": "悬浮物浓度",
              "Value": "9981",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2a6135bc-45b7-4c8d-933c-6d85a4ed030c",
          "EquipmentNo": "RJYND3_HYQMD_154",
          "EquipmentName": "3#溶解氧",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1221457+08:00",
              "ParamNo": "ND_53",
              "ParamName": "浓度",
              "Value": "5896",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a6a4e7de-53d3-4683-9fde-1ab8bbb59300",
          "EquipmentNo": "4#XFW_177",
          "EquipmentName": "4#悬浮物",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1231149+08:00",
              "ParamNo": "XFWND_57",
              "ParamName": "悬浮物浓度",
              "Value": "6765",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "84dc12c3-d7e3-4994-8d7e-f3688c166fcd",
          "EquipmentNo": "4#RJY_174",
          "EquipmentName": "4#溶解氧",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T14:59:43.1250787+08:00",
              "ParamNo": "ND_53",
              "ParamName": "浓度",
              "Value": "7670",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2287f936-341c-4885-bce2-ba7d1b2f3c67",
          "EquipmentNo": "1#ZXCDGNJ_58",
          "EquipmentName": "1#中心传动刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7252591+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7291587+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "06b6b703-fcf1-48fc-93e2-406e7913ff8e",
          "EquipmentNo": "2#ZXCDGNJ_129",
          "EquipmentName": "2#中心传动刮泥机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7320866+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7350192+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c636e18e-3339-44d4-b35d-216269dff7d1",
          "EquipmentNo": "1#HHJBJ_16",
          "EquipmentName": "1#混合搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7379483+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7399014+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "974d0e01-b2c6-4d2d-b1f8-1fb09bac77da",
          "EquipmentNo": "202309191144165071",
          "EquipmentName": "1#絮凝搅拌机_高效沉淀池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7428304+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.743806+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7467433+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "90fb7b22-2910-4fee-bb27-06ad656d5fcb",
          "EquipmentNo": "202309191152167341",
          "EquipmentName": "2#絮凝搅拌机_高效沉淀池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7477221+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "26.29847",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7506433+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7516212+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cb1bcfae-7606-4cce-aa67-6b0c469b164c",
          "EquipmentNo": "1#NWCJ_33",
          "EquipmentName": "1#泥位差计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7545471+08:00",
              "ParamNo": "NW_24",
              "ParamName": "泥位",
              "Value": "22799",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d66948bd-26aa-44f5-8d40-71d3312f5076",
          "EquipmentNo": "202309191350203659",
          "EquipmentName": "1#液位差计_高效沉淀池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7545471+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "5.620877",
              "Unit": "m",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d3311464-c209-4288-ac27-e8f37b5263a8",
          "EquipmentNo": "202309011603289492",
          "EquipmentName": "1#回流污泥泵_高效沉淀池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7574809+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7594411+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7623737+08:00",
              "ParamNo": "SCPL_9",
              "ParamName": "输出频率",
              "Value": "16589",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "eaed2897-596b-413d-9e04-ca51f92ab0ce",
          "EquipmentNo": "202309011605009210",
          "EquipmentName": "2#回流污泥泵_高效沉淀池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7633521+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7653024+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7672677+08:00",
              "ParamNo": "SCPL_9",
              "ParamName": "输出频率",
              "Value": "19354",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "bcf19a77-0607-4fb1-aa3d-a44c42dcfbd0",
          "EquipmentNo": "1#BYWNB_2",
          "EquipmentName": "1#备用污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7692059+08:00",
              "ParamNo": "SCPL_9",
              "ParamName": "输出频率",
              "Value": "17142",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7702039+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7731192+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "91e049f3-5b9c-4b70-8d25-8cf0d6326417",
          "EquipmentNo": "2#BYWNB_69",
          "EquipmentName": "2#备用污泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7750605+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7770215+08:00",
              "ParamNo": "SCPL_9",
              "ParamName": "输出频率",
              "Value": "17695",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.778971+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "599fbc2e-8721-4d17-a76c-156ee6c405ff",
          "EquipmentNo": "202309011452065006",
          "EquipmentName": "1#剩余污泥泵_高效沉淀池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7809257+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7818962+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f661aad0-5bc8-4976-8745-fbbd34773f7b",
          "EquipmentNo": "202309011453143640",
          "EquipmentName": "2#剩余污泥泵_高效沉淀池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:26.7838489+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:26.7848288+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9c95ee47-c32d-41af-9df5-0c0545ee23da",
          "EquipmentNo": "CY_FXFJA_243",
          "EquipmentName": "臭氧_反洗风机A",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.8895515+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.8924901+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.8963876+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "616b5a37-8d53-4a4c-bcb1-f5a4f56cde9a",
          "EquipmentNo": "CY_FXFJB_244",
          "EquipmentName": "臭氧_反洗风机B",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.8983514+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.9012655+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.903219+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f773895f-e642-4255-8610-3e78247052e3",
          "EquipmentNo": "PNB_264",
          "EquipmentName": "排泥泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9061575+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.9081051+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f81ca753-37df-4669-a7c3-8bdcadac74f5",
          "EquipmentNo": "CY_FXPS1#KGF_251",
          "EquipmentName": "臭氧_反洗排水1#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.910057+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a73f7154-0c6a-4a9b-8402-dc683c9a28f4",
          "EquipmentNo": "CY_FXPS2#KGF_252",
          "EquipmentName": "臭氧_反洗排水2#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9110275+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c58584bb-6551-42e9-a0ae-ff542ea5d255",
          "EquipmentNo": "CY_FXPS3#KGF_253",
          "EquipmentName": "臭氧_反洗排水3#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9149412+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4520f849-4c3b-4478-8018-0fdf110af239",
          "EquipmentNo": "CY_FXPS4#KGF_254",
          "EquipmentName": "臭氧_反洗排水4#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9168927+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d97cb4de-31bc-4811-9e76-658d89b2f2f8",
          "EquipmentNo": "CY_FXPS5#KGF_255",
          "EquipmentName": "臭氧_反洗排水5#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9188533+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a9d28b4c-4397-48cc-9afc-c932853a1a2c",
          "EquipmentNo": "CY_FXPS6#KGF_256",
          "EquipmentName": "臭氧_反洗排水6#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9207985+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f0dcaeeb-6fb4-4ff0-97a5-2982cd6ff245",
          "EquipmentNo": "CY_FXJQ1#KGF_245",
          "EquipmentName": "臭氧_反洗进气1#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9227583+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6472504e-d594-451b-a624-82b09b574979",
          "EquipmentNo": "CY_FXJQ2#KGF_246",
          "EquipmentName": "臭氧_反洗进气2#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9247067+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "fd2355b2-6f9f-4829-b1d7-fa9097155c22",
          "EquipmentNo": "CY_FXJQ3#KGF_247",
          "EquipmentName": "臭氧_反洗进气3#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9266543+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3b09b531-44dd-4818-8704-0fca53308f67",
          "EquipmentNo": "CY_FXJQ4#KGF_248",
          "EquipmentName": "臭氧_反洗进气4#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9286141+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d092084c-1bde-479d-9be9-3736faf431d8",
          "EquipmentNo": "CY_FXJQ5#KGF_249",
          "EquipmentName": "臭氧_反洗进气5#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9305613+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "78390f8b-4947-41f9-a146-bd75e3e8b7f1",
          "EquipmentNo": "CY_FXJQ6#KGF_250",
          "EquipmentName": "臭氧_反洗进气6#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9325144+08:00",
              "ParamNo": "KGFKDW_77",
              "ParamName": "开关阀开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6a523bc0-2b38-4cdc-a784-b95beb879b9e",
          "EquipmentNo": "202309191416461351",
          "EquipmentName": "1#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9344837+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "eb6493bd-7ffd-4ada-9e09-d2f59c71f934",
          "EquipmentNo": "YFPQ2#KGF_96",
          "EquipmentName": "2#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9373962+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "fa097891-c593-4288-9ecc-a71308072c8c",
          "EquipmentNo": "CYFPQ3#KGF_146",
          "EquipmentName": "3#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.940334+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d53601e5-737e-46e6-ac8e-3d5c84f29ccc",
          "EquipmentNo": "4#KGF_172",
          "EquipmentName": "4#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.943267+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ef62e6cb-7d88-4ec8-a097-2177aef788e5",
          "EquipmentNo": "202309191419311342",
          "EquipmentName": "5#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9461882+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2d58db27-5357-4688-87c8-a49162501494",
          "EquipmentNo": "6#KGF_189",
          "EquipmentName": "6#开关阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.950094+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "268cbdf6-86d2-4612-b673-79bb8e8f2148",
          "EquipmentNo": "CYFPQ1#_4",
          "EquipmentName": "1#臭氧流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9520467+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "73cf145b-5d92-4218-ba99-9f8b9507cccc",
          "EquipmentNo": "2#CYLL_71",
          "EquipmentName": "2#臭氧流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9549782+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f5050b22-f292-444c-96bf-533fdede2355",
          "EquipmentNo": "CYFPQ3#_140",
          "EquipmentName": "3#臭氧流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9559498+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "89e406df-d1e2-49c4-864c-c743e7478b40",
          "EquipmentNo": "CY_CYFPQ4#CYLL_168",
          "EquipmentName": "4#臭氧流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9579084+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "7fb60023-4d68-4a2b-871a-051fd8ff9a01",
          "EquipmentNo": "5#CYLL_178",
          "EquipmentName": "5#臭氧流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9598615+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "7cf6574f-0679-4f26-9db6-cd07f0d298bd",
          "EquipmentNo": "CYFPQ6#CYLLJ_186",
          "EquipmentName": "6#臭氧流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9618131+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "214ee165-7800-4a53-896f-8083a546533d",
          "EquipmentNo": "1#DJF_9",
          "EquipmentName": "1#调节阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9637638+08:00",
              "ParamNo": "FKXH_29",
              "ParamName": "反馈信号",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "bbf36f7d-1167-40b0-8df2-6201ac8f73ab",
          "EquipmentNo": "2#DJF_80",
          "EquipmentName": "2#调节阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9657193+08:00",
              "ParamNo": "FKXH_29",
              "ParamName": "反馈信号",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "e9af0492-59aa-471c-b4db-6f123d7457d3",
          "EquipmentNo": "3#DJF_143",
          "EquipmentName": "3#调节阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.967668+08:00",
              "ParamNo": "FKXH_29",
              "ParamName": "反馈信号",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0bf42896-e2aa-4695-98c4-91fac625f25b",
          "EquipmentNo": "4#DJF_170",
          "EquipmentName": "4#调节阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9706074+08:00",
              "ParamNo": "FKXH_29",
              "ParamName": "反馈信号",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "22c05d84-80f3-4f4d-b0cf-111ccbd87474",
          "EquipmentNo": "202309191407237883",
          "EquipmentName": "5#调节阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9725632+08:00",
              "ParamNo": "FKXH_29",
              "ParamName": "反馈信号",
              "Value": "无",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "79688fdb-4537-470f-99b0-b7d5c93fc0b3",
          "EquipmentNo": "6#DJF_188",
          "EquipmentName": "6#调节阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9755116+08:00",
              "ParamNo": "FKXH_29",
              "ParamName": "反馈信号",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4a6c6e58-7e7b-4b9b-88f0-c174ad3baa52",
          "EquipmentNo": "QWB_266",
          "EquipmentName": "潜污泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9784174+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.9803631+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "5680c6fb-fc2c-4a09-936d-03dc720aaf2c",
          "EquipmentNo": "1#PQCYND_37",
          "EquipmentName": "1#排气臭氧浓度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.982317+08:00",
              "ParamNo": "ND_53",
              "ParamName": "浓度",
              "Value": "0",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a41c6d0b-7394-4e80-b7dd-0abb579dea7b",
          "EquipmentNo": "2#PQCYND_106",
          "EquipmentName": "2#排气臭氧浓度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9852602+08:00",
              "ParamNo": "ND_53",
              "ParamName": "浓度",
              "Value": "0",
              "Unit": "mg/L",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "7ca54512-ca58-4a15-8471-ed54cb409651",
          "EquipmentNo": "1#WQPHQ_49",
          "EquipmentName": "1#尾气破坏器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9862252+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.988179+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3fb3fd32-a142-4051-a2a3-4961d134222e",
          "EquipmentNo": "2#WQPHQ_122",
          "EquipmentName": "2#尾气破坏器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:00:43.9891578+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:00:43.9911042+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "189afaa8-26f2-4ec7-ad60-e2d5fad7dba9",
          "EquipmentNo": "1#FSQ_12",
          "EquipmentName": "1#发生器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8127871+08:00",
              "ParamNo": "GZBJ_30",
              "ParamName": "故障报警",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8147343+08:00",
              "ParamNo": "SDZDMS_31",
              "ParamName": "手动自动模式",
              "Value": "手动",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8186449+08:00",
              "ParamNo": "YCBDMS_32",
              "ParamName": "远程本地模式",
              "Value": "远程",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "47aabf57-a437-47f3-9744-69624de995a2",
          "EquipmentNo": "1#SSCL_42",
          "EquipmentName": "1#实时产量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8196141+08:00",
              "ParamNo": "SSCL_54",
              "ParamName": "实时产量",
              "Value": "0",
              "Unit": "kg/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "512c4e30-d5ac-4459-9b43-e9e8780971a0",
          "EquipmentNo": "1#JQF_21",
          "EquipmentName": "1#进气阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8225546+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8254739+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "58a9474e-cc46-4324-9366-8e7e972b7cde",
          "EquipmentNo": "1#NXHB_32",
          "EquipmentName": "1#内循环泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8274286+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8293809+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c3979726-3295-4163-b0e6-295550113f41",
          "EquipmentNo": "1#NBQ_34",
          "EquipmentName": "1#逆变器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8313316+08:00",
              "ParamNo": "QD_10",
              "ParamName": "启动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8332875+08:00",
              "ParamNo": "ZDY_46",
              "ParamName": "主电源",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d36482ec-8055-4936-b825-40f695a4bf12",
          "EquipmentNo": "1#JQLD_23",
          "EquipmentName": "1#进气露点",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8352406+08:00",
              "ParamNo": "JQLD_42",
              "ParamName": "进气露点",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d747f8d5-e802-4b1a-8878-4a2e5a7b6788",
          "EquipmentNo": "1#JQYL_24",
          "EquipmentName": "1#进气压力",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8381732+08:00",
              "ParamNo": "JQYL_43",
              "ParamName": "进气压力",
              "Value": "0",
              "Unit": "KPa",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "efbca4fd-23e5-4a81-a603-273590570aea",
          "EquipmentNo": "1#JQLL_22",
          "EquipmentName": "1#进气流量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.841094+08:00",
              "ParamNo": "JQLL_41",
              "ParamName": "进气流量",
              "Value": "0",
              "Unit": "Nm3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "fe3df72b-4f0a-43f9-a608-f60c100325a2",
          "EquipmentNo": "1#YQXL_56",
          "EquipmentName": "1#氧气泄露",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.844027+08:00",
              "ParamNo": "YQXL_61",
              "ParamName": "氧气泄露",
              "Value": "0",
              "Unit": "%",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6ffcdc12-26ee-4cf0-88e8-30e701899fcd",
          "EquipmentNo": "202309041056123978",
          "EquipmentName": "1#臭氧泄漏",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8450073+08:00",
              "ParamNo": "CYXL_17",
              "ParamName": "臭氧泄漏",
              "Value": "0",
              "Unit": "ppm",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c8e4b713-98f4-402d-ac81-f4439771619e",
          "EquipmentNo": "202309011853042253",
          "EquipmentName": "1#系统功率",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8469608+08:00",
              "ParamNo": "XTGL_56",
              "ParamName": "系统功率",
              "Value": "0",
              "Unit": "Kw",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d7c630c2-acc0-48d3-a690-d79d59570c0d",
          "EquipmentNo": "202309041134236246",
          "EquipmentName": "1#臭氧浓度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8489135+08:00",
              "ParamNo": "CYND_16",
              "ParamName": "臭氧浓度",
              "Value": "0",
              "Unit": "g/Nm3",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "dee3aa13-900e-4cdd-8c45-c88692ecb63b",
          "EquipmentNo": "202309041119425229",
          "EquipmentName": "1#出水温度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8508804+08:00",
              "ParamNo": "CSWD_21",
              "ParamName": "出水温度",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6867cd55-49e9-4284-8134-5e2aec46d308",
          "EquipmentNo": "202309041116075260",
          "EquipmentName": "1#出气温度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8518391+08:00",
              "ParamNo": "CQWD_20",
              "ParamName": "出气温度",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "665e9e80-3064-456f-b24a-6b101393cd9d",
          "EquipmentNo": "202309041109277359",
          "EquipmentName": "1#出气开度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8547721+08:00",
              "ParamNo": "CQKDFK_19",
              "ParamName": "出气开度",
              "Value": "0",
              "Unit": "%",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6d526f2c-282e-42ac-96bc-0970ce5c0573",
          "EquipmentNo": "_2#CYZB_83",
          "EquipmentName": "2#发生器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8567209+08:00",
              "ParamNo": "SDZDMS_31",
              "ParamName": "手动自动模式",
              "Value": "手动",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8577039+08:00",
              "ParamNo": "YCBDMS_32",
              "ParamName": "远程本地模式",
              "Value": "远程",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8596562+08:00",
              "ParamNo": "GZBJ_30",
              "ParamName": "故障报警",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2ff00d61-7db3-419d-bf5f-e7d4db632b45",
          "EquipmentNo": "202309041038177169",
          "EquipmentName": "2#实时产量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8606271+08:00",
              "ParamNo": "SSCL_54",
              "ParamName": "实时产量",
              "Value": "0",
              "Unit": "kg/h",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0c97619a-967e-4434-81d6-65d63caaef8f",
          "EquipmentNo": "2#JQF_91",
          "EquipmentName": "2#进气阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.862583+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8635558+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6b46ae9b-ffc6-4776-b055-8e1f608cf253",
          "EquipmentNo": "2#NXHB_102",
          "EquipmentName": "2#内循环泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8664951+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8674651+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "c9129eb7-cf01-4e0d-b8dd-0211d4ab4b73",
          "EquipmentNo": "2#NBQ_103",
          "EquipmentName": "2#逆变器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8694159+08:00",
              "ParamNo": "ZDY_46",
              "ParamName": "主电源",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8713678+08:00",
              "ParamNo": "QD_10",
              "ParamName": "启动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "23ac7e30-7e60-4cf5-8d42-1d544eda227e",
          "EquipmentNo": "2#JQLD_93",
          "EquipmentName": "2#进气露点",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8733319+08:00",
              "ParamNo": "JQLD_42",
              "ParamName": "进气露点",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d4c81d17-dfd6-4791-b156-b717e0bc6cd8",
          "EquipmentNo": "2#JQYL_94",
          "EquipmentName": "2#进气压力",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8762535+08:00",
              "ParamNo": "JQYL_43",
              "ParamName": "进气压力",
              "Value": "0",
              "Unit": "KPa",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4e36108b-c939-4f52-80a5-3d7cbed8458a",
          "EquipmentNo": "2#JQLL_92",
          "EquipmentName": "2#进气流量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8782078+08:00",
              "ParamNo": "JQLL_41",
              "ParamName": "进气流量",
              "Value": "0",
              "Unit": "Nm3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9e4a1776-e274-4f50-bf7b-89a616aaf149",
          "EquipmentNo": "202309011854004469",
          "EquipmentName": "2#系统功率",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8791905+08:00",
              "ParamNo": "XTGL_56",
              "ParamName": "系统功率",
              "Value": "0",
              "Unit": "Kw",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "506430ff-5e42-4794-94f0-03dea02698f7",
          "EquipmentNo": "2#CYND_72",
          "EquipmentName": "2#臭氧浓度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8821144+08:00",
              "ParamNo": "CYND_16",
              "ParamName": "臭氧浓度",
              "Value": "0",
              "Unit": "g/Nm3",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "36eaef95-63e5-48b0-99eb-72aa9afc7fa2",
          "EquipmentNo": "2#CSWD_77",
          "EquipmentName": "2#出水温度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8840672+08:00",
              "ParamNo": "CSWD_21",
              "ParamName": "出水温度",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d3ec7da2-8840-4288-9b29-45efa5b7476a",
          "EquipmentNo": "2#CQWD_76",
          "EquipmentName": "2#出气温度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8850404+08:00",
              "ParamNo": "CQWD_20",
              "ParamName": "出气温度",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d242d94d-ef9c-4fff-8a16-19ee231d6ef3",
          "EquipmentNo": "2#CQKD_75",
          "EquipmentName": "2#出气开度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8870128+08:00",
              "ParamNo": "CQKDFK_19",
              "ParamName": "出气开度",
              "Value": "0",
              "Unit": "%",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b34132c6-1b46-41b6-96e7-9dd376d6109b",
          "EquipmentNo": "3#FSQ_144",
          "EquipmentName": "3#发生器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 3,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8899395+08:00",
              "ParamNo": "GZBJ_30",
              "ParamName": "故障报警",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8918843+08:00",
              "ParamNo": "SDZDMS_31",
              "ParamName": "手动自动模式",
              "Value": "手动",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.8938366+08:00",
              "ParamNo": "YCBDMS_32",
              "ParamName": "远程本地模式",
              "Value": "远程",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "567b6997-172f-4e8d-ae79-10e13188dbdf",
          "EquipmentNo": "202309041039492686",
          "EquipmentName": "3#实时产量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8957905+08:00",
              "ParamNo": "SSCL_54",
              "ParamName": "实时产量",
              "Value": "0",
              "Unit": "kg/h",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "5d41ab15-9a63-4e32-bf1b-bd812f1d6920",
          "EquipmentNo": "202309041128577774",
          "EquipmentName": "3#进气阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.8977381+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.9006806+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2864e6c1-bc00-49a3-9479-fb181c244129",
          "EquipmentNo": "3#NXHB_150",
          "EquipmentName": "3#内循环泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9026298+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.9045774+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6cba8227-3698-4c33-a9a5-cc900bff762d",
          "EquipmentNo": "3#NBQ_151",
          "EquipmentName": "3#逆变器",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9075057+08:00",
              "ParamNo": "QD_10",
              "ParamName": "启动",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:12.909458+08:00",
              "ParamNo": "ZDY_46",
              "ParamName": "主电源",
              "Value": "无",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d6cc486b-8eef-4fe9-8b5f-fc378a88d343",
          "EquipmentNo": "202309041034234342",
          "EquipmentName": "3#进气露点",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9104339+08:00",
              "ParamNo": "XTGL_56",
              "ParamName": "系统功率",
              "Value": null,
              "Unit": "Kw",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d3e77994-29ba-4c91-917b-fa384432b14e",
          "EquipmentNo": "202309041123052508",
          "EquipmentName": "3#进气压力",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.912389+08:00",
              "ParamNo": "JQYL_43",
              "ParamName": "进气压力",
              "Value": "0",
              "Unit": "KPa",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "8dba480d-a116-40a0-9f5d-7099c164cf99",
          "EquipmentNo": "202309041125474658",
          "EquipmentName": "3#进气流量",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9153209+08:00",
              "ParamNo": "JQLL_41",
              "ParamName": "进气流量",
              "Value": "0",
              "Unit": "Nm3/h",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d0b8133b-5921-463a-b4b3-9c05e83f822f",
          "EquipmentNo": "3#XTGL_160",
          "EquipmentName": "3#系统功率",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9182582+08:00",
              "ParamNo": "XTGL_56",
              "ParamName": "系统功率",
              "Value": "0",
              "Unit": "Kw",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "93d81e12-177d-47a9-aa07-199bcb5fb39f",
          "EquipmentNo": "202309041135386648",
          "EquipmentName": "3#臭氧浓度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9211778+08:00",
              "ParamNo": "CYND_16",
              "ParamName": "臭氧浓度",
              "Value": "0",
              "Unit": "g/Nm3",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d73caf5a-7e76-4e4f-885a-516ba8be49ad",
          "EquipmentNo": "202309041120471597",
          "EquipmentName": "3#出水温度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9231278+08:00",
              "ParamNo": "CSWD_21",
              "ParamName": "出水温度",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b709494e-bbb9-45b1-b1ae-6ddc6fed9ae9",
          "EquipmentNo": "202309041117007093",
          "EquipmentName": "3#出气温度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.9250872+08:00",
              "ParamNo": "CQWD_20",
              "ParamName": "出气温度",
              "Value": "0",
              "Unit": "℃",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "d1155871-4b9d-4180-9f93-4fea074d43dd",
          "EquipmentNo": "202309041110154666",
          "EquipmentName": "3#出气开度",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:12.927034+08:00",
              "ParamNo": "CQKDFK_19",
              "ParamName": "出气开度",
              "Value": "0",
              "Unit": "%",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "be106390-ed2b-49ff-a6b5-ac542413b6a7",
          "EquipmentNo": "YSN_1#CG_275",
          "EquipmentName": "乙酸钠_1#储罐",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.5778972+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0.1038973",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ecaec0e6-9c1b-4f88-8e54-cb505c541f22",
          "EquipmentNo": "YSN_2#CG_276",
          "EquipmentName": "乙酸钠_2#储罐",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.5818035+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "1.19179",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "051e245a-245f-4499-aa0b-551d63261d6d",
          "EquipmentNo": "YSN_3#CG_277",
          "EquipmentName": "乙酸钠_3#储罐",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.5847321+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0.1037164",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a62886e8-c8b0-4e7d-aa0f-ef5d461273e5",
          "EquipmentNo": "XLB_270",
          "EquipmentName": "乙酸钠卸料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.5876931+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.5896167+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "5d160d56-8e44-464c-a744-ba62959490ce",
          "EquipmentNo": "1#JYB_18",
          "EquipmentName": "乙酸钠1#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.5915706+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.5935249+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.5964508+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.5984051+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "23a647d3-5a82-4060-858d-ed294231f203",
          "EquipmentNo": "2#JYB_88",
          "EquipmentName": "乙酸钠2#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6003586+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "34.99756",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6032892+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6052447+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0.53",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6071947+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "896c33dd-83d2-46dc-ad5a-88f08253be41",
          "EquipmentNo": "3#JYB_145",
          "EquipmentName": "乙酸钠3#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6101233+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6130725+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6150075+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6169697+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "39ffc357-4054-4b62-80fd-bc3f98bc7e5b",
          "EquipmentNo": "JSF_261",
          "EquipmentName": "进水阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6189389+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "391d077e-4ecf-454e-bcfb-9a902d1d6eb5",
          "EquipmentNo": "JBJ_260",
          "EquipmentName": "搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.620896+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6238247+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ff1fc2f1-ec93-47ee-bff0-0b5a9c5f631a",
          "EquipmentNo": "PAC_YW_218",
          "EquipmentName": "PAC_液位",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6257557+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "0.9387738",
              "Unit": "m",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "7dd043ad-7f2b-4f47-9e32-f512b3148da7",
          "EquipmentNo": "202309011818197776",
          "EquipmentName": "PAC卸料泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6286824+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6316107+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "6e00caf5-2776-4a34-89a3-c051849d589d",
          "EquipmentNo": "202309011755176459",
          "EquipmentName": "PAC1#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6335654+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6345394+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6365165+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6384728+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "242fa7db-0f93-4e36-9ff6-bdb66d3b6db1",
          "EquipmentNo": "202309011756594941",
          "EquipmentName": "PAC2#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6394535+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6413763+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.643364+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6462643+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "07cf81ce-5062-4c05-afbc-b55137622f2e",
          "EquipmentNo": "202309011758181340",
          "EquipmentName": "PAC3#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.647249+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6501627+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6530969+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6540839+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "34.99756",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "31bbe20f-ecdc-424a-a218-3eb01196cc8e",
          "EquipmentNo": "202309011801236987",
          "EquipmentName": "PAC4#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6569984+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6589558+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6618904+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6638392+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a59ff3e9-90ca-4a9e-be94-6d5c115e779c",
          "EquipmentNo": "202309011748101978",
          "EquipmentName": "PAM1#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6667679+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6697024+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6706918+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6736083+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "8e5f21a8-f923-4745-bc63-c5ad5e73fd8d",
          "EquipmentNo": "202309011750028166",
          "EquipmentName": "PAM2#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6746024+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.676535+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "1.15",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6784838+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "34.99756",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6814128+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "74dc4714-ea1c-4e7e-a071-1f7b44bb61ab",
          "EquipmentNo": "202309011751403536",
          "EquipmentName": "PAM3#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.6833675+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6863005+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "1.19",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6892426+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "34.99756",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6921543+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "7cc131b4-e796-4c71-9170-d293541771ab",
          "EquipmentNo": "202309011753083685",
          "EquipmentName": "PAM4#加药泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.694109+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.696059+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.6989924+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "1.14",
              "Unit": "A",
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7019227+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "34.99756",
              "Unit": "Hz",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ef1f1b9c-939a-43dc-8da3-86e7fa7425ff",
          "EquipmentNo": "PAM_YZJSF_25",
          "EquipmentName": "PAM_一组进水阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7028966+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "0d55023c-032a-41b8-a00b-ce19823e7e33",
          "EquipmentNo": "11#JBJ_65",
          "EquipmentName": "11#搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7048509+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7068013+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "88b9e780-4724-49fb-9a42-8a320d4e2cb5",
          "EquipmentNo": "12#JBJ_66",
          "EquipmentName": "12#搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7097315+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.711687+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "592a39a4-e3f2-499f-8634-2fd5b44857b1",
          "EquipmentNo": "1#TJJ_48",
          "EquipmentName": "1#投加机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7146204+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "0",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7165787+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7175456+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7194995+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "46949a19-c086-464a-bfce-7aac7ae60c2a",
          "EquipmentNo": "PAM_EZJSF_95",
          "EquipmentName": "PAM_二组进水阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7214585+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "42b90475-9126-4443-916f-7ffe5302aa60",
          "EquipmentNo": "PAM_EZ1#JBJ_136",
          "EquipmentName": "PAM_二组1#搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7243805+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7263407+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "cab29f69-23e7-44d4-bae0-3fa46fd133bd",
          "EquipmentNo": "PAM_EZ2#JBJ_137",
          "EquipmentName": "PAM_二组2#搅拌机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7273099+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7292634+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "5d52d5a3-a0ce-4f3e-a238-0c671da7748e",
          "EquipmentNo": "2#TJJ_121",
          "EquipmentName": "2#投加机",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 4,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:01:48.7312185+08:00",
              "ParamNo": "PL_6",
              "ParamName": "频率",
              "Value": "34.99756",
              "Unit": "Hz",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7331685+08:00",
              "ParamNo": "DL_40",
              "ParamName": "电流",
              "Value": "0.89",
              "Unit": "A",
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.7341472+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:01:48.737083+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "086873e5-58c2-42f6-863e-e578ac8715fa",
          "EquipmentNo": "202309011704116055",
          "EquipmentName": "1#链条式刮泥机_纤维转盘滤池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9220061+08:00",
              "ParamNo": "QT_33",
              "ParamName": "启停",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "dcbf66b4-1b84-406f-8f10-73870a960b76",
          "EquipmentNo": "202309011709582625",
          "EquipmentName": "2#链条式刮泥机_纤维转盘滤池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.924943+08:00",
              "ParamNo": "QT_33",
              "ParamName": "启停",
              "Value": "停止",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "aa0c5e33-f0cd-4ffb-84a9-91c7e4d38c8e",
          "EquipmentNo": "202309191507184411",
          "EquipmentName": "1#液位差计_纤维转盘滤池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9278741+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "10",
              "Unit": "m",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "220208d9-1044-4b4d-944e-1bcfd26d4bc3",
          "EquipmentNo": "202309191507561667",
          "EquipmentName": "2#液位差计_纤维转盘滤池",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9308063+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "9.262153",
              "Unit": "m",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "5dc4ed0b-f8df-4b0e-9845-853a88701140",
          "EquipmentNo": "A_1FXB_192",
          "EquipmentName": "A_1反洗泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.932759+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b5b195af-eb70-4002-8cfb-50c9c3eef776",
          "EquipmentNo": "A_2FXB_195",
          "EquipmentName": "A_2反洗泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9347153+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "47f14d6c-6d1a-4776-a237-d208647e056b",
          "EquipmentNo": "A_1PNF_194",
          "EquipmentName": "A_1排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9376388+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9395994+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "b3dd41d2-bd75-4973-ac34-31aa8579ca65",
          "EquipmentNo": "A_2PNF_197",
          "EquipmentName": "A_2排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9425139+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.94448+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "f0cfd1e1-a1dc-4cfd-88d1-a3bd6cde65e7",
          "EquipmentNo": "A_1FXF_193",
          "EquipmentName": "A_1反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9474103+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9484056+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "8a72acc3-46bd-4cb2-b90c-dc43e02a835f",
          "EquipmentNo": "A_2FXF_196",
          "EquipmentName": "A_2反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9513142+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.954244+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "40892936-6d33-4f89-aeb7-1fb57690641f",
          "EquipmentNo": "A_3FXF_198",
          "EquipmentName": "A_3反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9561924+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.957166+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "5214f416-4f26-4636-b0a7-f0ebd92f6efd",
          "EquipmentNo": "A_4FXF_199",
          "EquipmentName": "A_4反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9591518+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9610738+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9d270206-c8fc-42f9-9234-a119ce651e33",
          "EquipmentNo": "B_1FXB_200",
          "EquipmentName": "B_1反洗泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9630293+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "895f3ef6-9b86-4ffa-84e8-de9354e3c672",
          "EquipmentNo": "B_2FXB_203",
          "EquipmentName": "B_2反洗泵",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9669292+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "e3008913-fb4d-4c09-b730-8976d31fc2be",
          "EquipmentNo": "B_1PNF_202",
          "EquipmentName": "B_1排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.970835+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9727999+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a8b3e1f6-1883-40d2-8154-d23d10716962",
          "EquipmentNo": "B_2PNF_205",
          "EquipmentName": "B_2排泥阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9737743+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9747408+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "fb3b0e80-e1af-49af-8ed6-5469490d5dd3",
          "EquipmentNo": "B_1FXF_201",
          "EquipmentName": "B_1反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9767058+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9776695+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "44785b46-bef0-4411-87d4-e6648d6adff3",
          "EquipmentNo": "B_2FXF_204",
          "EquipmentName": "B_2反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.979623+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9815757+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "3a6cdf2c-cee9-4a06-9d20-0ef804738d0c",
          "EquipmentNo": "B_3FXF_206",
          "EquipmentName": "B_3反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9835277+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9854808+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "4112ad68-8cf9-4f61-b02f-5fcb902f9b5b",
          "EquipmentNo": "B_4FXF_207",
          "EquipmentName": "B_4反洗阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:15.9864654+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:15.9884173+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "1e4aa2d5-915c-463c-bf5d-c7f4b4d748e4",
          "EquipmentNo": "1#LXBX_28",
          "EquipmentName": "1#离心泵（小）",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9555634+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9584988+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "9ef3876c-f451-445a-aed2-84c665449990",
          "EquipmentNo": "2#LXBX_98",
          "EquipmentName": "2#离心泵（小）",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9624188+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9653396+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "a356a47d-3506-4110-bc50-5004a6ec317d",
          "EquipmentNo": "3#LXBX_147",
          "EquipmentName": "3#离心泵（小）",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9672884+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9702151+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "ee5c873e-a911-4e77-b210-9dc7f970a907",
          "EquipmentNo": "1#LXBD_27",
          "EquipmentName": "1#离心泵（大）",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9721678+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9731481+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "停止",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "593c3569-ae9f-48e4-b529-1312092b27f9",
          "EquipmentNo": "2#LXBD_97",
          "EquipmentName": "2#离心泵（大）",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9770512+08:00",
              "ParamNo": "YX_14",
              "ParamName": "运行状态",
              "Value": "运行",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9780248+08:00",
              "ParamNo": "GZ_12",
              "ParamName": "故障状态",
              "Value": "正常",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "7fe1eed7-4a60-4f63-b1b5-8892c6f95102",
          "EquipmentNo": "1#DDF_8",
          "EquipmentName": "1#电动阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9799814+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9819365+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "是",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "efa6b2f4-affc-49b7-89d1-bcd59b51924f",
          "EquipmentNo": "2#DDF_79",
          "EquipmentName": "2#电动阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9838892+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9868163+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "67480013-64f8-41db-b8ce-f463c1ce965f",
          "EquipmentNo": "3#DDF_142",
          "EquipmentName": "3#电动阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9887647+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9897422+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "dbc2aa31-c102-4e6e-8eb0-2242fed91d0a",
          "EquipmentNo": "4#DDF_169",
          "EquipmentName": "4#电动阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9917001+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9946323+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "82b1e527-b015-4be6-9af1-10ba31204d7a",
          "EquipmentNo": "5#DDF_ZSXT_179",
          "EquipmentName": "5#电动阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:42.9965819+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:42.9985519+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "是",
              "Unit": null,
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "90521bd3-4967-406e-a36b-6f034ad6f6e5",
          "EquipmentNo": "6#DDF_187",
          "EquipmentName": "6#电动阀",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 2,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:43.000494+08:00",
              "ParamNo": "KDW_28",
              "ParamName": "开到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            },
            {
              "TimeStamp": "2023-10-17T15:02:43.0024455+08:00",
              "ParamNo": "GDW_26",
              "ParamName": "关到位",
              "Value": "否",
              "Unit": null,
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "1834ea1f-a008-4c69-a5e4-af1ffe517cee",
          "EquipmentNo": "LLJ_262",
          "EquipmentName": "流量计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:43.0034172+08:00",
              "ParamNo": "LL_15",
              "ParamName": "流量",
              "Value": "0",
              "Unit": "m3/h",
              "NormalRange": null,
              "RangeFlag": null
            }
          ]
        },
        {
          "EquipmentID": "2875f06b-5266-4575-824b-810b1947588f",
          "EquipmentNo": "YWJ_ZSXT_273",
          "EquipmentName": "液位计",
          "ProjectNo": "ybws",
          "ProjectID": "2ecb7011-71d7-4be9-9743-feef688fd335",
          "ListCount": 1,
          "ListParam": [
            {
              "TimeStamp": "2023-10-17T15:02:43.0053754+08:00",
              "ParamNo": "YW_64",
              "ParamName": "液位",
              "Value": "6.689453",
              "Unit": "m",
              "NormalRange": ",",
              "RangeFlag": null
            }
          ]
        }
      ],
      "records": 8,
      "costtime": "32"
    },
    "timestamp": "2023-10-17 14:52:41"
  }
}

// 根据阶段分类的实时数据查询
export function getLatestByConfig(data){
  return request({
    url:'Collector/GetLatestByConfig',
    method:'post',
    data:data
  })
}

// 根据阶段分类的历史数据查询
export function getHistoryByConfig(data){
  return request({
    url:'Collector/GetHistoryByConfig',
    method:'post',
    data:data
  })
}

// 设备报警列表
export function getAlarm(data){
  return request({
    url:'EquipmentAlarm/GetListJson',
    method:'post',
    data:data
  })
}

// 多设备历史数据查询
export function getHistorysApi(data){
  return request({
    url:'Collector/GetHistoryData',
    method:'post',
    data:data
  })
}